import { getRequest } from '../../requests';
import { select, put } from 'redux-saga/effects';
import { orderBy, downloadCsv } from '../../misc';

export function loadCommissionSummary(action, path) {
  const { page, per_page, id } = action.params;
  const url = `/${path}/${id}`;
  const params = { page, per_page };
  return getRequest(url, params);
}

export function loadDirectMerchantCommission(action, url) {
  const { page, per_page, order_direction, order_by } = action.params;
  const params = { page, per_page, order_by, order_direction };
  return getRequest(url, params);
}

export function loadPartnerCommission(action, url) {
  const { page, per_page, order_direction, order_by } = action.params;
  const params = { page, per_page, order_by, order_direction };
  return getRequest(url, params);
}

export function* handleLoadUpdateCommission(action, options) {
  const page = yield select(
    state =>
      state.commissionPayouts[options.slice.commissionType].show.currentPage
  );
  const perPage = yield select(
    state =>
      state.commissionPayouts[options.slice.commissionType].show.perPageFilter
  );
  const activeTable = yield select(
    state =>
      state.commissionPayouts[options.slice.commissionType].show.activeTable
  );

  const config = { params: { page, id: options.slice.id, per_page: perPage } };

  if (action.type.includes('DOWNLOAD_CSV')) {
    yield downloadCsv(action.path, null, config);
  } else {
    if (action.type.includes('UPDATE_LOAD_COMMISSION_SHOW')) {
      yield loadTable(action.params.newActiveTable, config, options);
    } else {
      yield loadTable(activeTable, config, options);
    }
  }
}

const normalizeOrderByType = (orderByType, currentTable) => {
  let type;
  if (currentTable === 'directMerchant')
    switch (orderByType) {
      case 'created_at':
        type = 'CreatedAt';
        break;
      case 'merchant_name':
        type = 'MerchantName';
        break;
      case 'transaction_amount':
        type = 'ProcessingVolume';
        break;
      case 'transaction_fee':
        type = 'TransactionFee';
        break;
      case 'revenue_share':
        type = 'Commission';
        break;
      default:
        break;
    }
  if (currentTable === 'partners')
    switch (orderByType) {
      case 'company_name':
        type = 'CompanyName';
        break;
      case 'transaction_amount_sum':
        type = 'ProcessingVolume';
        break;
      case 'transaction_fee_sum':
        type = 'TransactionFee';
        break;
      case 'revenue_share_sum':
        type = 'Commission';
        break;
      case 'merchant_count':
        type = 'NumMerchants';
        break;
      default:
        break;
    }
  return `orderBy${type}State`;
};

function* loadTable(currentTable, config, options) {
  if (currentTable === 'Direct Merchants') {
    const orderByType = yield select(
      state =>
        state.commissionPayouts[options.slice.commissionType].show
          .directMerchant.orderByType
    );
    const orderConfig = yield handleOrderBy(
      orderByType,
      'directMerchant',
      options
    );
    Object.assign(config, { params: { ...config.params, ...orderConfig } });

    const response = yield options.method.handleLoadDirectMerchantCommission(
      config
    );
    yield options.method.calculatePagination(
      response.data.commissions_count,
      config.params.per_page,
      options.method.setPaginatorTotal
    );
    yield put(options.method.setCommissionDirectMerchants(response.data));
  }
  if (currentTable === 'Partners') {
    const orderByType = yield select(
      state =>
        state.commissionPayouts[options.slice.commissionType].show.partners
          .orderByType
    );
    const orderConfig = yield handleOrderBy(orderByType, 'partners', options);
    Object.assign(config, { params: { ...config.params, ...orderConfig } });

    const response = yield options.method.handleLoadPartnerCommission(config);
    yield options.method.calculatePagination(
      response.data.referral_details_count,
      config.params.per_page,
      options.method.setPaginatorTotal
    );
    yield put(options.method.setCommissionPartners(response.data));
  }
}

function* handleOrderBy(orderByType, currentTable, options) {
  const normalizedType = normalizeOrderByType(orderByType, currentTable);
  const orderByState = yield select(
    state =>
      state.commissionPayouts[options.slice.commissionType].show[currentTable][
        normalizedType
      ]
  );
  return orderBy(orderByType, orderByState);
}
